/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingSubscriptionChargeInvoicePdfRetrievePathParameters,
  BillingV1SubscriptionChargesDestroyPathParameters,
  BillingV1SubscriptionChargesListParams,
  BillingV1SubscriptionChargesPaidMarkPathParameters,
  BillingV1SubscriptionChargesPaidUnmarkPathParameters,
  BillingV1SubscriptionChargesPartialUpdatePathParameters,
  BillingV1SubscriptionChargesRetrievePathParameters,
  CursorPaginatedSubscriptionChargeResponseV1,
  PatchedSubscriptionChargePatchRequestV1Request,
  SubscriptionChargeCreateRequestV1Request,
  SubscriptionChargeResponseV1,
  SubscriptionChargeTriggerRequestV1Request,
  SubscriptionChargeTriggerResponseV1
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingSubscriptionChargeService {
  private readonly http = inject(HttpClient);
/**
 * Any authenticated caller, auto-scoped by role (M-bill-12): an admin sees every row and may narrow with `?user_id`; a regular user sees only their own charges, and `?user_id` of another user yields an empty page (filter, not lookup). Returns SubscriptionCharge rows ordered by `period_start` desc by default (`?date_order=asc` reverses). All filters composable: `?user_id`, `?subscription_id`, `?from_date`/`?to_date`, `?paid` (true/false — absent = no filter).
 * @summary List subscription charges (role-scoped, cursor-paginated).
 */
 billingV1SubscriptionChargesList<TData = CursorPaginatedSubscriptionChargeResponseV1>(params?: BillingV1SubscriptionChargesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionChargesList<TData = CursorPaginatedSubscriptionChargeResponseV1>(params?: BillingV1SubscriptionChargesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionChargesList<TData = CursorPaginatedSubscriptionChargeResponseV1>(params?: BillingV1SubscriptionChargesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionChargesList<TData = CursorPaginatedSubscriptionChargeResponseV1>(
    params?: BillingV1SubscriptionChargesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/subscription_charges/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/subscription_charges/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/subscription_charges/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. Manual create — emits ONE SubscriptionCharge with client-supplied snapshots (no Config KV read, no cadence derivation, no SIM lines materialized: `lines=[]`). For the batch trigger multi-select UX, use `POST .../subscription_charges/trigger/`.
 *
 * Cross-field validation: `subscription.user_id == user_id`; mismatch → 409 `/problems/subscription-user-subscription-mismatch`. `period_end > period_start` (422 `/problems/period-end-not-after-start`). `total_net = system_fee_uf * uf_to_clp_at_snapshot * months_billed_at_snapshot` (server-side computed). A period that crosses another charge of the subscription → 409 `/problems/subscription-charge-overlap` (M-bill-20). A `period_start` inside the subscription grace emits a grace charge: fee and amounts at 0, `is_grace`, born paid (M-bill-20).
 * @summary Create ONE subscription charge manually (correctivo admin path).
 */
 billingV1SubscriptionChargesCreate<TData = SubscriptionChargeResponseV1>(subscriptionChargeCreateRequestV1Request: SubscriptionChargeCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionChargesCreate<TData = SubscriptionChargeResponseV1>(subscriptionChargeCreateRequestV1Request: SubscriptionChargeCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionChargesCreate<TData = SubscriptionChargeResponseV1>(subscriptionChargeCreateRequestV1Request: SubscriptionChargeCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionChargesCreate<TData = SubscriptionChargeResponseV1>(
    subscriptionChargeCreateRequestV1Request: SubscriptionChargeCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/subscription_charges/`,
      subscriptionChargeCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/subscription_charges/`,
      subscriptionChargeCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/subscription_charges/`,
      subscriptionChargeCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Returns the SubscriptionCharge without its lines — they live in the `.../lines/` sub-resource (M-bill-4), one row per SIM of the user in the period. Those lines are INFORMATIONAL and do NOT sum into `total_net` (that is the UF snapshot × months, per the model docstring).
 * @summary Retrieve one subscription charge.
 */
 billingV1SubscriptionChargesRetrieve<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionChargesRetrieve<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionChargesRetrieve<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionChargesRetrieve<TData = SubscriptionChargeResponseV1>(
    { identity }: BillingV1SubscriptionChargesRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/subscription_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/subscription_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/subscription_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Preserve-on-omit. **Post-payment exception** (M-bill-1e load-bearing rule #3): when `paid_at` is set, the endpoint accepts a body with ONLY `invoice_number` (SII folio registered after emitting the invoice); any other field → 409 `/problems/subscription-charge-paid`. Pre-payment: `system_fee_uf` recomputes `total_net`, `iva` and `total` (M-bill-6); `invoice_number` persisted as sent.
 * @summary Partial-update a subscription charge (preserve-on-omit).
 */
 billingV1SubscriptionChargesPartialUpdate<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesPartialUpdatePathParameters,
    patchedSubscriptionChargePatchRequestV1Request?: PatchedSubscriptionChargePatchRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionChargesPartialUpdate<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesPartialUpdatePathParameters,
    patchedSubscriptionChargePatchRequestV1Request?: PatchedSubscriptionChargePatchRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionChargesPartialUpdate<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesPartialUpdatePathParameters,
    patchedSubscriptionChargePatchRequestV1Request?: PatchedSubscriptionChargePatchRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionChargesPartialUpdate<TData = SubscriptionChargeResponseV1>(
    { identity }: BillingV1SubscriptionChargesPartialUpdatePathParameters,
    patchedSubscriptionChargePatchRequestV1Request?: PatchedSubscriptionChargePatchRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v1/billing/subscription_charges/${identity}/`,
      patchedSubscriptionChargePatchRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v1/billing/subscription_charges/${identity}/`,
      patchedSubscriptionChargePatchRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v1/billing/subscription_charges/${identity}/`,
      patchedSubscriptionChargePatchRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. CASCADE drops the SubscriptionChargeLine rows. Refused with 409 `/problems/subscription-charge-paid` when the charge is already marked paid — paid charges are the client audit trail, immutable.
 * @summary Hard-delete a subscription charge (unpaid only).
 */
 billingV1SubscriptionChargesDestroy<TData = void>(pathParams: BillingV1SubscriptionChargesDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionChargesDestroy<TData = void>(pathParams: BillingV1SubscriptionChargesDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionChargesDestroy<TData = void>(pathParams: BillingV1SubscriptionChargesDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionChargesDestroy<TData = void>(
    { identity }: BillingV1SubscriptionChargesDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/subscription_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/subscription_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/subscription_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Any authenticated caller, auto-scoped by role (M-bill-12): a regular user only resolves their own charges — someone else's identity answers the same 404 as a nonexistent one. Returns a binary PDF with the subscription charge detail. The PDF is informational, not a SII tax document. IVA and total are read from the snapshot written at charge creation (M-bill-6), never recomputed. Rendered synchronously, nothing is stored.
 * @summary Download the invoice PDF of a subscription charge
 */
 billingSubscriptionChargeInvoicePdfRetrieve(pathParams: BillingSubscriptionChargeInvoicePdfRetrievePathParameters, options?: HttpClientBodyOptions): Observable<Blob>;
 billingSubscriptionChargeInvoicePdfRetrieve(pathParams: BillingSubscriptionChargeInvoicePdfRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 billingSubscriptionChargeInvoicePdfRetrieve(pathParams: BillingSubscriptionChargeInvoicePdfRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  billingSubscriptionChargeInvoicePdfRetrieve(
    { identity }: BillingSubscriptionChargeInvoicePdfRetrievePathParameters, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/v1/billing/subscription_charges/${identity}/invoice.pdf`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/v1/billing/subscription_charges/${identity}/invoice.pdf`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/v1/billing/subscription_charges/${identity}/invoice.pdf`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }
/**
 * Admin-only. Sets `paid_at=now()` + `paid_by=<caller>`. Idempotent: a second POST on an already-paid row does NOT rewrite the timestamps (the audit trail keeps the original marker). Body is empty; the caller identity comes from the JWT.
 * @summary Mark a subscription charge as paid (idempotent).
 */
 billingV1SubscriptionChargesPaidMark<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesPaidMarkPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionChargesPaidMark<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesPaidMarkPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionChargesPaidMark<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesPaidMarkPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionChargesPaidMark<TData = SubscriptionChargeResponseV1>(
    { identity }: BillingV1SubscriptionChargesPaidMarkPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/subscription_charges/${identity}/paid_marks/`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/subscription_charges/${identity}/paid_marks/`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/subscription_charges/${identity}/paid_marks/`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Resets `paid_at=None` + `paid_by=None`. Idempotent. Use this before editing (other than `invoice_number`) or deleting a paid charge. A grace charge (M-bill-20) stays paid: 409 `/problems/subscription-charge-is-grace`.
 * @summary Unmark a subscription charge as paid (idempotent).
 */
 billingV1SubscriptionChargesPaidUnmark<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesPaidUnmarkPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionChargesPaidUnmark<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesPaidUnmarkPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionChargesPaidUnmark<TData = SubscriptionChargeResponseV1>(pathParams: BillingV1SubscriptionChargesPaidUnmarkPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionChargesPaidUnmark<TData = SubscriptionChargeResponseV1>(
    { identity }: BillingV1SubscriptionChargesPaidUnmarkPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/subscription_charges/${identity}/paid_marks/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/subscription_charges/${identity}/paid_marks/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/subscription_charges/${identity}/paid_marks/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Path `POST .../subscription_charges/trigger/` (sub-path, RPC-style action — for manual single-charge create use `POST .../subscription_charges/`). Emits SubscriptionCharge rows for the requested `period_start`. `user_ids` is an array of User ids matching the admin front multi-select UX: omit or `null` to trigger for every eligible user (batch mode); pass an array to target those users only. Empty array `[]` is rejected (send `null` for "all"). Any id that does not resolve to a User → 404 `/problems/user-not-found` (with the list); any targeted user without an active Sub on `period_start` → 409 `/problems/subscription-charge-trigger-no-active-sub` (with the list). Batch is ATOMIC — if any single charge fails, the whole batch rolls back. Optional `system_fee_uf_override` snapshots a per-trigger UF fee instead of reading `SYSTEM_FEE_UF` Config. Returns 201 with `{identities: [...]}` — each identity resolves via `GET .../subscription_charges/{identity}/`.
 *
 * M-bill-20: a subscription whose `period_start` already falls inside one of its charges (an annual mid-year, or the same month triggered twice) gets nothing, so `identities` can be empty. A `period_start` inside the grace emits a one-month charge at 0, `is_grace` and born paid, whatever the override. An annual charge covers 12 months and bills `ANNUAL_BILLING_MONTHS` of them.
 * @summary Trigger batch emission of subscription charges for a period.
 */
 billingV1SubscriptionChargesTrigger<TData = SubscriptionChargeTriggerResponseV1>(subscriptionChargeTriggerRequestV1Request: SubscriptionChargeTriggerRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionChargesTrigger<TData = SubscriptionChargeTriggerResponseV1>(subscriptionChargeTriggerRequestV1Request: SubscriptionChargeTriggerRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionChargesTrigger<TData = SubscriptionChargeTriggerResponseV1>(subscriptionChargeTriggerRequestV1Request: SubscriptionChargeTriggerRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionChargesTrigger<TData = SubscriptionChargeTriggerResponseV1>(
    subscriptionChargeTriggerRequestV1Request: SubscriptionChargeTriggerRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/subscription_charges/trigger/`,
      subscriptionChargeTriggerRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/subscription_charges/trigger/`,
      subscriptionChargeTriggerRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/subscription_charges/trigger/`,
      subscriptionChargeTriggerRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type BillingV1SubscriptionChargesListClientResult = NonNullable<CursorPaginatedSubscriptionChargeResponseV1>
export type BillingV1SubscriptionChargesCreateClientResult = NonNullable<SubscriptionChargeResponseV1>
export type BillingV1SubscriptionChargesRetrieveClientResult = NonNullable<SubscriptionChargeResponseV1>
export type BillingV1SubscriptionChargesPartialUpdateClientResult = NonNullable<SubscriptionChargeResponseV1>
export type BillingV1SubscriptionChargesDestroyClientResult = NonNullable<void>
export type BillingSubscriptionChargeInvoicePdfRetrieveClientResult = NonNullable<Blob>
export type BillingV1SubscriptionChargesPaidMarkClientResult = NonNullable<SubscriptionChargeResponseV1>
export type BillingV1SubscriptionChargesPaidUnmarkClientResult = NonNullable<SubscriptionChargeResponseV1>
export type BillingV1SubscriptionChargesTriggerClientResult = NonNullable<SubscriptionChargeTriggerResponseV1>
